import { render } from "./PurchaseTabs.vue?vue&type=template&id=72a0096e&scoped=true"
import script from "./PurchaseTabs.vue?vue&type=script&lang=js"
export * from "./PurchaseTabs.vue?vue&type=script&lang=js"

import "./PurchaseTabs.vue?vue&type=style&index=0&id=72a0096e&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a0096e"]])

export default __exports__